import * as type from '../constants/assessmentSectionQuestions';

const initialState = {
    isLoading: false,
    questions: [],
    savePartialQuestionsLoading: false,
};

function assessmentSectionQuestionsReducer(state = initialState, action = {}) {

    switch (action.type) {
        case type.GET_QUESTIONS:
            return {
                ...state,
                isLoading: true,
            };
        case type.GET_QUESTIONS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                questions: action.questions,
            };
        case type.GET_QUESTIONS_FAIL:
            return {
                ...state,
                error: action.error,
                isLoading: false,
            };
        case type.SAVE_PARTIAL_QUESTIONS_PROGRESS:
        case type.SAVE_QUESTIONS_PROGRESS:
            return {
                ...state,
                savePartialQuestionsLoading: true,
            };
        case type.SAVE_QUESTIONS_PROGRESS_SUCCESS:
            return {
                ...state,
                report: action.scores,
                scores: action.scores,
                isLoading: false,
            };
        case type.SAVE_QUESTIONS_PROGRESS_FAIL:
        case type.SAVE_PARTIAL_QUESTIONS_PROGRESS_SUCCESS:
        case type.SAVE_PARTIAL_QUESTIONS_PROGRESS_FAIL:
            return {
                ...state,
                savePartialQuestionsLoading: false,
            };
        case type.RESET_ASSESSMENT_QUESTIONS:
            return { ...initialState, isLoading: false };
        default:
            return state;
    }
}

export default assessmentSectionQuestionsReducer;
